module.exports = __webpack_public_path__ + "img/achievement_4.b353869b.png";